<template>
    <div class="repCharac">
        <div class="titlePage">Historial de Caracterización</div>
        <modal
        name="HistoryModal"
        width="80%"
        height="auto"
        :scrollable="true"
        :adaptive="true"
        :clickToClose="true"
        style="overflow:scroll"
        >
        <div class="container htmlData">
          <div v-for="item of this.infoHistory" :key="item.id" class="row">
            <template v-if="item.value === 'title'">
                <div class='titleRefZone col-md-12'>{{item.label}}</div>
            </template>
            <template v-else>
                <div class='LabelSumary col-md-6'>{{item.label}}</div>
                <div class='ValueSumary col-md-6' v-if="item.value === true">Si</div>
                <div class='ValueSumary col-md-6' v-else-if="item.value === false">No</div>
                <div class='ValueSumary col-md-6' v-else>{{item.value}}</div>
            </template>
          </div>
        </div>
        </modal>
        <va-notification v-if="noDtaForm" color="danger" class="refNoData">No se encuentran formularios en este momento.</va-notification>
        <div class="col-md-12 text-left">
            <button class="loginbtn primaryBtn primaryBtn" type="submit" v-on:click="LinkBack()">
                <va-icon name="fa fa-arrow-left" size="60" /> Regresar
            </button>
        </div>

        <div class="listData" v-if="!noDtaForm">
            <DataList
                :InfoView="this.DLDataList"
                :HeadTable="this.HDDataList"
                Report=""
                :method="executeprocess"
                v-if="renderComponent1"
            />
        </div>

        <div class="col-md-6 text-left">
            <router-link :to="'/admin/FormCharacterization/'+this.$route.params.idCaract">
                <button class="loginbtn primaryBtn primaryBtn" >
                    <va-icon name="fa fa-arrow-left" size="60" /> Regresar
                </button>
            </router-link>
        </div>
    </div>
</template>

<script>
import IberoHelpers from '@/store/helpers.js'
import DataList from '@/components/data-tables/DataListCharact.vue'

export default {
  name: 'repCharac',
  components: {
    DataList,
  },
  data () {
    return {
      infoHistory: [],
      renderComponent1: false,
      HDDataList: [
        {
          name: 'IdPersonCharact',
          title: 'Id',
          width: '10%',
        },
        {
          name: 'NamCharacterization',
          title: 'Nombre',
          width: '40%',
        },
        {
          name: '__slot:dateCretedExe',
          title: 'Fecha Diligenciamiento',
          dataClass: 'text-left',
          width: '20%',
        },
        {
          name: '__slot:statusHistory',
          title: 'Activo',
          dataClass: 'text-center',
          width: '10%',
        },
        {
          name: '__slot:history',
          dataClass: 'text-center',
          actionRef: [
            {
              label: 'Editar',
              icon: 'fa-pencil',
              action: 'show',
            },
          ],
        },
      ],
      DLDataList: [],
      FormHList: [],
      noDtaForm: false,
    }
  },
  methods: {
    LinkBack () {
      return this.$router.push({ path: '/admin/FormCharacterization/' + this.$route.params.idCaract })
    },
    executeprocess (info) {
      this.infoHistory.length = 0
      var infoForm = JSON.parse(info.DetPersonCharact)
      for (var i = 0; i < info.FormCharact.length; i++) {
        var valreference = ''
        if (info.FormCharact[i].TypeCharactForm !== 'title') {
          valreference = infoForm['id_' + info.FormCharact[i].IdCharactForm]
        } else {
          valreference = 'title'
        }
        this.infoHistory.push({ label: info.FormCharact[i].NamCharactForm, value: valreference })
      }
      this.$modal.show('HistoryModal')
    },
  },
  created: function () {
    let loader = this.$loading.show()
    var listCaract = IberoHelpers.getDatCaractbyIdPerson(this.$store, this.$route.params.idCaract, this.$session.get('IberoJWTAdminLogin').idPerson)
    listCaract.then(Response => {
      if (Response.data === '') {
        this.noDtaForm = true
      } else {
        this.DLDataList = Response.data.Characterizations
        this.noDtaForm = false
        IberoHelpers.forceRerender1(this)
      }
      loader.hide()
    })
  },
}
</script>